import { IcsCalendarEventType, } from './store/schema/IcsPreviewState';
import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "IcsPreview" */ './lazyIndex');
});
export var lazyAddToCalendar = new LazyImport(lazyModule, function (m) { return m.addToCalendar; });
export var lazyGetIcsCalendarItem = new LazyImport(lazyModule, function (m) { return m.getIcsCalendarItem; });
export var lazyGetIcsCalendarItemOrchestrator = new LazyImport(lazyModule, function (m) { return m.getIcsCalendarItemOrchestrator; });
export { AddToCalendarStatus, IcsCalendarEventType, };
export var IcsPreview = createLazyComponent(lazyModule, function (m) { return m.IcsPreview; });
//# sourceMappingURL=index.js.map